// extracted by mini-css-extract-plugin
export default {"row":"UserItem_row__gL8J6","info":"UserItem_info__mWEJ9","additional":"UserItem_additional__cDUg0","name":"UserItem_name__gG4eP"};